import { useSearchParams } from "react-router-dom";
import { useState, useEffect } from "react";
import Stepper from "routes/Services/stepper";
import Badge from "components/General/Badge";
import { isFlagEnabled } from "js/utilities";
import { odsClaimStatusConversion } from "js/formatting";

const ClaimsList = ({ data, setOpenChatWindow, type, primaryOwner = null }) => {
  const [showTracker, setShowTracker] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [statusClass, statusText] = odsClaimStatusConversion(
    data.claimStatus,
    data.claimType
  );

  useEffect(() => {
    if (data?.taskID === searchParams.get("taskID")) setShowTracker(true);
  }, [searchParams]);

  return (
    <div className="ui-card-bar relative mt-2">
      <div className="px-3 py-2 lg:p-4">
        <div className="grid grid-cols-1 md:grid-cols-6 gap-2 xl:gap-2">
          <div className="md:col-span-2">
            <div className="font-body text-theme-text-primary">
              {primaryOwner}
            </div>
            <div className="text-sm text-theme-text-secondary">
              <Badge
                status={statusClass}
                statusText={statusText}
                srPrefix="Claim"
                iconOnly={false}
                type={type}
              />
            </div>
          </div>
          <p className="col-span-1 flex items-center">
            {data.claimType === "DIS" ? "Disability Claim" : "Death Claim"}
          </p>
          <p className="col-span-1 flex items-center">{data.oldPolicy}</p>
          <p className="col-span-1 flex items-center">{data.claimNumber}</p>
          <div className="col-span-1 flex items-center flex-row justify-between">
            <p>
              {/* {data.claimType === "DIS"
                ? data.claimOpenedDate
                : data.dateOfNotification} */}
              {data.dateReceived}
            </p>
            <button
              className="ui-btn-hyperlink"
              type="button"
              onClick={() =>
                isFlagEnabled("ENABLE_SHOWING_SERVICE_TRACKER") &&
                setShowTracker(!showTracker)
              }
            >
              {showTracker ? (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M4.5 15.75L12 8.25L19.5 15.75" stroke="#007BC1" />
                </svg>
              ) : (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M19.5 8.25L12 15.75L4.5 8.25" stroke="#007BC1" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>
      {isFlagEnabled("ENABLE_SHOWING_SERVICE_TRACKER") && showTracker && (
        <Stepper status={statusText} setOpenChatWindow={setOpenChatWindow} />
      )}
    </div>
  );
};

export default ClaimsList;
